import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
  flex-direction: column;
`

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.deepGray};
  margin: 0;
  line-height: 1.2;
  margin-bottom: 0.5em;
`

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.deepGray};
  line-height: 1.5;
  margin: 0;
  max-width: 60ch;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.skyBlue};
`
